// @ts-nocheck
import { teal } from 'api';
import { requestStarted, requestSucceeded, requestFailed } from 'store/slices/apiCalls';

const withApiCall = async (dispatch, key, callback) => {
    dispatch(requestStarted({ key }));

    try {
        const data = await callback();
        dispatch(requestSucceeded({ key }));
        return data;
    } catch (error) {
        dispatch(requestFailed({ key, error }));
        return error;
    }
};

export function createScrape(pdf) {
    return async (dispatch) => withApiCall(dispatch, 'scrapes.createScrape', () => teal.createScrape({ pdf }));
}

export function convertContentToScrape(content, fileId, penlyUserId, organisationId) {
    return async (dispatch) => withApiCall(dispatch, 'scrapes.convertContentToScrape', () => teal.convertContentToScrape({ content, fileId, penlyUserId, organisationId }));
}

export function getAllScrapes() {
    return async (dispatch) => withApiCall(dispatch, 'scrapes.getAllScrapes', () => teal.getAllScrapes());
}

export function getAllScrapesByPenlyUserId(organisationId, penlyUserId) {
    return async (dispatch) => withApiCall(dispatch, 'scrapes.getAllScrapesByPenlyUserId', () => teal.getAllScrapesByPenlyUserId(organisationId, penlyUserId));
}

export function getScrape(scrapeId) {
    return async (dispatch) => withApiCall(dispatch, 'scrapes.getScrape', () => teal.getScrape({ scrapeId }));
}

export function deleteScrape(scrapeId) {
    return async (dispatch) => withApiCall(dispatch, 'scrapes.deleteScrape', () => teal.deleteScrape({ scrapeId }));
}
